import { Button } from "@chakra-ui/button"
import { VStack, Box } from "@chakra-ui/layout"
import { InfinityIcon } from "lib/icons"
import { FC } from "react"

type Props = {
  ungroupItems: () => Promise<void>;
  borderRadius?: string;
}

export const ButtonUngroupItems: FC<Props> = ({ ungroupItems, ...style }) => {
  return (
    <Button onClick={() => ungroupItems()} colorScheme="brand" fontSize="xs" height="100%" {...style}>
      <VStack spacing="3px">
        <Box><InfinityIcon boxSize="22px" /></Box>
        <Box>Ungroup items</Box>
      </VStack>
    </Button>
  )
};
